/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import * as color from '@constant/color';
import * as font from '@constant/font';
import * as size from '@constant/size';
import BoxBlock from '@component/common/block/box-block';
import { IBlock } from '@datatype/type';

// wrapper에 height 설정을 안하니, 크기가 이상하게 바뀜
const Wrapper = styled(BoxBlock)<Pick<IProps, 'design'>>``;

interface IProps extends IBlock {
  name: string;
  value: string;
  placeholder: string;
  row?: number;
  max?: number;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
  type?: 'text' | 'password';
  // autoComplete?: 'on' | 'off';
}

const TextArea = styled.textarea<Pick<IProps, 'design'>>`
  all: unset;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  resize: none;

  // font
  font: ${(props) => {
    switch (props.design?.text?.size) {
      case 'tiny':
        return `${font.FONT_TINY_400}`;
      case 'small':
        return `${font.FONT_SMALL_400}`;
      case 'medium':
        return `${font.FONT_MEDIUM_400}`;
      case 'large':
        return `${font.FONT_LARGE_400}`;
      case 'big':
        return `${font.FONT_BIG_400}`;
      case 'huge':
        return `${font.FONT_HUGE_400}`;
      default:
    }
  }};

  &::placeholder {
    font: ${(props) => {
      switch (props.design?.text?.size) {
        case 'tiny':
          return `${font.FONT_TINY_400}`;
        case 'small':
          return `${font.FONT_SMALL_400}`;
        case 'medium':
          return `${font.FONT_MEDIUM_400}`;
        case 'large':
          return `${font.FONT_LARGE_400}`;
        case 'big':
          return `${font.FONT_BIG_400}`;
        case 'huge':
          return `${font.FONT_HUGE_400}`;
        default:
      }
    }};
  }

  color: ${(props) => props.design?.text?.color || color.BLACK_2};
  font-weight: ${(props) => (props.design?.text?.bold ? '600' : '400')};
  // line-height: 10px;
`;

const TextAreaInput: React.FC<IProps> = ({ name, value, placeholder, row = 1, max, design, onChange }) => {
  return (
    <Wrapper design={design}>
      <TextArea
        placeholder={placeholder}
        rows={row}
        maxLength={max}
        // autoComplete={'off'}
        name={name}
        design={design}
        onChange={onChange}
        value={value}
      />
    </Wrapper>
  );
};

export default TextAreaInput;
